<lib-dba-mat-dialog-title (cancelClick)="dialogRef.close()">
  {{Title}} 
</lib-dba-mat-dialog-title>

<mat-dialog-content>
  @if(loading){<lib-spinner-dialog></lib-spinner-dialog>}


  
  <doc-documents [documentList]="documentList"  [maxImageAmount]="4"></doc-documents>
  
</mat-dialog-content>

<mat-dialog-actions>
  <lib-dba-mat-dialog-footer (cancelClick)="dialogRef.close()" (saveClick)="Save()"></lib-dba-mat-dialog-footer>
</mat-dialog-actions>